import React from "react";
import { useNavigate, useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { Post } from "../../config/api/post";
import { AUTH } from "../../config/constants";
import { addUser } from "../../redux/slice/authSlice";
import { AuthPage, LoginForm } from "../../components/login-form";
import { toast } from "sonner";

function Signin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("error_code") === "session_expired") {
      toast.error("Your session expired. Please log in again.");
      navigate("/signin", { replace: true });
    }
  }, [location.search, navigate]);

  React.useEffect(() => {
    if (token) {
      navigate("/", { replace: true });
    }
  }, [token, navigate]);

  const onSubmit = (values) => {
    if (!values.email || !values.password) {
      toast.error("Please enter your email and password.");
      return;
    }
    if (values.password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }

    setLoading(true);

    Post(AUTH.signin, {
      email: values.email,
      password: values.password,
    })
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          toast.success(response.data.message || "Logged in successfully");
          dispatch(
            addUser({
              user: response.data.data.user,
              token: response.data.data.token,
            })
          );
          navigate("/", { replace: true });
        } else {
          toast.error(
            response?.data?.message || response?.response?.data?.message || "Login failed"
          );
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.data?.message || e?.message || "Login failed");
      });
  };

  return (
    <AuthPage>
      <LoginForm
        title="Welcome back"
        description="Log in to your Birchwood admin account."
        submitLabel="Log in"
        loading={loading}
        onSubmit={onSubmit}
        fields={[
          {
            name: "email",
            label: "Email",
            type: "email",
            placeholder: "admin@birchwood.local",
            autoComplete: "email",
          },
          {
            name: "password",
            label: "Password",
            type: "password",
            placeholder: "Enter your password",
            autoComplete: "current-password",
            minLength: 8,
            action: (
              <a
                href="/forgot-password"
                className="shrink-0 text-xs font-medium text-primary underline-offset-4 hover:underline"
                onClick={(event) => {
                  event.preventDefault();
                  navigate("/forgot-password");
                }}
              >
                Forgot password?
              </a>
            ),
          },
        ]}
      />
    </AuthPage>
  );
}

export default Signin;
